import { IOrderItem, IProduct } from '@monofront/types';
import { useTranslations } from 'use-intl';
import { OrderProduct } from './OrderProduct';
import { useEffect, useState } from 'react';
import { productService } from '@services/businessContainer';
import { useRouter } from 'next/router';
import { getChannelFromLocale } from '@monofront/business/utils';

interface IOrderProductListProps {
  orderProducts: IOrderItem[];
}

export const OrderProductList: React.FC<IOrderProductListProps> = ({
  orderProducts,
}) => {
  const tAccount = useTranslations('Account');
  const [products, setProducts] = useState<IProduct[]>([]);
  const { locale } = useRouter();
  const channel = getChannelFromLocale(locale);

  useEffect(() => {
    const getProductInformation = async () => {
      const productsSku = orderProducts.map((product) => product.sku);
      const products = await productService.getProductsBySku(
        productsSku,
        channel,
      );

      setProducts(products);
    };

    getProductInformation();
  }, []);

  const getCurrentProductHandle = (sku: string) => {
    const product = products.find((product) => product.sku === sku);

    return product?.handle ?? '';
  };

  return (
    <section className="product-list tw-mt-4 md:tw-mt-12">
      <div className="separator md:tw-py-10">
        <div className="header-items tw-py-2 md:tw-py-0">
          <p className="tw-font-semibold">{tAccount('orderDetails')}</p>
          <p className="tw-lf-body-bold-sm md:tw-pr-4">
            {tAccount.rich('orderNbProducts', {
              nb: orderProducts.length,
              span: (children) => (
                <span className="tw-font-title tw-text-base tw-font-semibold">
                  {children}
                </span>
              ),
            })}
          </p>
        </div>
        <p className="tw-mr-4 tw-hidden tw-text-right tw-font-body tw-text-base md:tw-block">
          {tAccount('subTotal')}
        </p>
      </div>
      <ul>
        {orderProducts.map((item: IOrderItem) => (
          <li key={item.sku}>
            <OrderProduct
              handle={getCurrentProductHandle(item.sku)}
              orderProduct={item}
            />
          </li>
        ))}
      </ul>
      <style jsx>{`
        .header-items {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .subtotal {
          padding: 0 var(--space-4);
        }

        .subtotal {
          text-align: right;
          margin: var(--space-4) 0;
        }

        .separator {
          border-top: var(--border);
          border-bottom: var(--border);
        }

        .product-count {
          font-family: var(--font-family-1);
        }

        @media (max-width: 800px) {
          .subtotal {
            display: none;
          }
          .header-items {
            margin-top: 0;
          }
          .product-list {
            margin-bottom: var(--space-8);
          }
        }
      `}</style>
    </section>
  );
};
